import React, { useState } from "react";
import DatabasePage from "./DatabasePage";
import GenericSupplyTable from "./GenericSupplyTable";
import NeedsOrderingPanel from "./NeedsOrderingPanel";
import S from "../styles";

const API_URL = process.env.REACT_APP_API_URL || "https://api.nycmanufacturing.com";

const TABS = [
  { key: "filament", label: "Filament" },
  { key: "acrylic", label: "Acrylic" },
  { key: "hardware", label: "Hardware" },
  { key: "shipping", label: "Shipping Supplies" },
];

export default function SuppliesPage({ materials, setMaterials, filament, setFilament, hardware, setHardware, shippingSupplies, setShippingSupplies }) {
  const [tab, setTab] = useState("filament");

  const apiCrud = (base, queryStr = "") => ({
    onAdd: (data, cb) => {
      fetch(`${API_URL}${base}${queryStr}`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
        .then((r) => r.json()).then((created) => { if (created.id) cb(created); }).catch(() => {});
    },
    onEdit: (id, data) => {
      fetch(`${API_URL}${base}/${id}${queryStr}`, { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) }).catch(() => {});
    },
    onDelete: (id) => {
      fetch(`${API_URL}${base}/${id}${queryStr}`, { method: "DELETE" }).catch(() => {});
    },
  });

  return (
    <div>
      <main style={S.main}>
        <div style={{ marginBottom: 4 }}>
          <h2 style={{ fontFamily: "'Archivo Black', 'Archivo', sans-serif", fontSize: 32, fontWeight: 900, color: "#0A0A0F", letterSpacing: "-0.02em", textTransform: "uppercase", lineHeight: 1, marginBottom: 4 }}>Materials & Supplies</h2>
          <p style={{ fontSize: 14, color: "rgba(10,10,15,0.58)", marginBottom: 16 }}>Manage inventory across all supply categories</p>
        </div>
        <div style={{ marginBottom: 24 }}>
          <nav style={S.nav}>
            {TABS.map(({ key, label }) => (
              <button key={key} onClick={() => setTab(key)} style={{ ...S.navBtn, ...(tab === key ? S.navBtnActive : {}) }}>{label}</button>
            ))}
          </nav>
        </div>
        {tab === "acrylic" && <DatabasePage materials={materials} setMaterials={setMaterials} />}
        {tab === "filament" && (
          <GenericSupplyTable
            title="Filament" items={filament} setItems={setFilament}
            {...apiCrud("/api/filament")}
            columns={[
              { key: "material", label: "Material", width: "16%", placeholder: "e.g. PLA+" },
              { key: "brand", label: "Brand", width: "16%", placeholder: "e.g. Hatchbox" },
              { key: "color", label: "Color", width: "14%", placeholder: "e.g. Black" },
              { key: "weight", label: "Weight", width: "12%", placeholder: "1kg" },
              { key: "sku", label: "SKU", width: "16%", placeholder: "SKU #" },
              { key: "price", label: "Price", width: "12%", placeholder: "0.00", type: "number", align: "right", isCurrency: true },
            ]}
          />
        )}
        {tab === "hardware" && (
          <>
          <NeedsOrderingPanel hardware={hardware} location="nycmfg" />
          <GenericSupplyTable
            title="Hardware" items={hardware} setItems={setHardware}
            {...apiCrud("/api/hardware", "?location=nycmfg")}
            rowStyle={(item) => (item.isLow ? { background: "rgba(194,65,15,0.10)" } : {})}
            columns={[
              { key: "name", label: "Item Name", width: "20%", placeholder: "e.g. M5 x 12 screw" },
              { key: "category", label: "Category", width: "12%", placeholder: "e.g. Fasteners" },
              { key: "sku", label: "SKU / Part #", width: "12%", placeholder: "Part #" },
              {
                key: "quantity", label: "On hand", width: "11%", placeholder: "0", type: "number", align: "center",
                render: (item) => {
                  const qty = Number(item.quantity) || 0;
                  const pack = Number(item.packQty) || 1;
                  return (
                    <span>
                      {qty}
                      {pack > 1 && <span style={{ color: "rgba(10,10,15,0.45)", fontSize: 12, marginLeft: 6 }}>{(qty / pack).toFixed(1)} pk</span>}
                    </span>
                  );
                },
              },
              { key: "packQty", label: "Pack of", width: "8%", placeholder: "100", type: "number", align: "center" },
              {
                key: "lowAt", label: "Low at", width: "8%", placeholder: "150", type: "number", align: "center",
                render: (item) => (item.lowAt == null ? "—" : item.lowAt),
              },
              {
                key: "buyUrl", label: "Reorder", width: "10%", placeholder: "https://amazon…",
                render: (item) =>
                  item.buyUrl ? (
                    <a href={item.buyUrl} target="_blank" rel="noreferrer" style={{ color: "#0033FF", fontSize: 12 }}>Buy</a>
                  ) : "—",
              },
              { key: "price", label: "Pack price", width: "10%", placeholder: "0.00", type: "number", align: "right", isCurrency: true },
            ]}
          />
          </>
        )}
        {tab === "shipping" && (
          <GenericSupplyTable
            title="Shipping Supplies" items={shippingSupplies} setItems={setShippingSupplies}
            {...apiCrud("/api/shipping-supplies", "?location=nycmfg")}
            columns={[
              { key: "name", label: "Item Name", width: "20%", placeholder: "e.g. Bubble Mailers" },
              { key: "size", label: "Size", width: "12%", placeholder: '8x12"' },
              { key: "brand", label: "Brand", width: "14%", placeholder: "e.g. Uline" },
              { key: "sku", label: "SKU", width: "14%", placeholder: "SKU #" },
              { key: "quantity", label: "Qty", width: "8%", placeholder: "0", type: "number", align: "center" },
              { key: "price", label: "Price", width: "10%", placeholder: "0.00", type: "number", align: "right", isCurrency: true },
            ]}
          />
        )}
      </main>
    </div>
  );
}
